import { Component } from '@angular/core';
import { environment } from '../environments/environment';
import { IonicModule } from '@ionic/angular';
import { EnvironmentBannerModule } from '@libs/ui/environment-banner';

@Component({
  selector: 'fma-root',
  templateUrl: 'app.component.html',
  styleUrls: ['app.component.scss'],
  imports: [IonicModule, EnvironmentBannerModule],
})
export class AppComponent {
  environment = environment.appEnvironment;
}
